import React, { useState } from 'react';
import UsersTable from './components/UsersTable';
import CreateModal from './components/CreateModal';

const Users = () => {
  const [totalFilter, setTotalFilter] = useState(0);
  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Daftar Pengguna</h1>
          <div className="d-flex">
            <button
              type="button"
              className="button -md h-50 bg-blue-1 text-white mr-20"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal">
              <i className="fa fa-filter mr-10" />
              Filter Data ( {totalFilter > 0 ? totalFilter : 0} )
            </button>

            <button
              className="button -md h-50 bg-blue-1 text-white"
              data-bs-toggle="modal"
              data-bs-target="#createModal">
              <i className="fa fa-envelope mr-10" />
              Invite Pengguna
            </button>
          </div>
        </div>
        <div className="px-30 rounded-4 bg-white shadow-3 mt-20 p-5">
          <UsersTable onFilterLengthChanged={(val) => setTotalFilter(val)} />
        </div>
      </div>
      {/* End .col-12 */}
      <CreateModal />
    </div>
  );
};

export default Users;
